import { mapEventToImage, importAll } from '../../constants';
import { useNavigate } from 'react-router-dom';

export default function MobileVerticalEventCard({event}) {
    const images = importAll(require.context('../../assets/eventImages', false, /\.(png|jpe?g|svg)$/));
    const imageKey = mapEventToImage[event.id];
    const navigate = useNavigate();
    const date = new Date(event.start_time);
    const options = {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
        hour: 'numeric', 
        minute: 'numeric'
      };
    const dateTimeString = date.toLocaleTimeString('en-US', options);

    const onClick = () => {
        navigate(`/event/${event.id}`);
    }
    return (
        <div className="container px-3 pb-3">
            <div className="card w-100" onClick={onClick}>
                <img src={images[imageKey]} className="img-fluid" alt=""/>                   
                <div className="row pt-2 px-1">
                    <h5>{event.name}</h5>
                    <p>{event.venues[0].name} | {dateTimeString}</p>
                </div>
            </div>
        </div>
    )
}